import { AnimatePresence, motion } from "framer-motion";
import { Box, Typography, Button, IconButton } from "@mui/material";
import {
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { setSelectedIds as setSelectedIdsAction } from "../../store/slices/filesSlice";
import { toggleStarBulkThunk } from "../../store/slices/filesSlice";

const BulkSelectionToolbar = ({ selectedIds, enableFavorites = true }) => {
  const dispatch = useDispatch();
  const handleCancelSelection = () => {
    dispatch(setSelectedIdsAction([]));
  };
  const toggleFavoritesForSelected = (isFavorites) => {
    dispatch(
      toggleStarBulkThunk({
        ids: Array.from(selectedIds),
        starred: isFavorites,
      })
    );
  };
  return (
    <>
      {/* Bulk Selection Toolbar - Material Design 3 */}
      <AnimatePresence>
        {selectedIds.size > 0 && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
          >
            <Box
              sx={{
                px: 2,
                py: 1,
                bgcolor: "#E3F2FD",
                borderBottom: "1px solid #2932E5",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: "Roboto, sans-serif",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#2932E5",
                  }}
                >
                  {selectedIds.size} item{selectedIds.size !== 1 ? "s" : ""}{" "}
                  selected
                </Typography>
                {enableFavorites && (
                  <>
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<StarIcon />}
                      onClick={() => toggleFavoritesForSelected(true)}
                      sx={{
                        textTransform: "none",
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "13px",
                        height: 32,
                        color: "#FF8555",
                        borderColor: "#FF8555",
                        "&:hover": {
                          borderColor: "#FF8555",
                          bgcolor: "rgba(255, 133, 85, 0.08)",
                        },
                      }}
                    >
                      Add to Favorites
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<StarBorderIcon />}
                      onClick={() => toggleFavoritesForSelected(false)}
                      sx={{
                        textTransform: "none",
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "13px",
                        height: 32,
                        color: "#4A5565",
                        borderColor: "#E5E7EB",
                        "&:hover": {
                          borderColor: "#4A5565",
                          bgcolor: "rgba(74, 85, 101, 0.04)",
                        },
                      }}
                    >
                      Remove from Favorites
                    </Button>
                  </>
                )}
              </Box>
              <IconButton
                size="small"
                onClick={handleCancelSelection}
                sx={{
                  color: "#2932E5",
                  "&:hover": {
                    bgcolor: "rgba(41, 50, 229, 0.08)",
                  },
                }}
                aria-label="Clear selection"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default BulkSelectionToolbar;
